import {lazy} from 'react';

export default lazy(() => import('./routes/ModuleRoutes'));
